export function Logo({ size = "md" }) {
  const height = size === "lg" ? 72 : 40;
  return (
    <img
      src="/logo.png"
      alt="Pregoeiros Summit"
      style={{ height, width: "auto" }}
      className="object-contain"
      data-testid="brand-logo"
    />
  );
}

export function LiveBadge({ live }) {
  if (!live) return (
    <span className="inline-flex items-center gap-1.5 text-xs font-data uppercase tracking-wider text-slate-400 bg-white/5 px-2.5 py-1 rounded-full">
      <span className="w-2 h-2 rounded-full bg-slate-500" /> Em breve
    </span>
  );
  return (
    <span data-testid="live-badge" className="inline-flex items-center gap-1.5 text-xs font-data uppercase tracking-wider text-white bg-red-600/90 px-2.5 py-1 rounded-full shadow-[0_0_12px_rgba(220,38,38,0.5)]">
      <span className="w-2 h-2 rounded-full bg-white animate-pulse" /> Ao vivo
    </span>
  );
}
